import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ChevronDown } from "@app/components/common/icons";

type Props = {
  necessary: string;
  nonNecessary: string;
  isNotNecessaryEnabled: boolean;
  toggleNotNecessary: (value: boolean) => void;
};

export const CookiesUsage: React.FC<Props> = ({
  necessary,
  nonNecessary,
  isNotNecessaryEnabled,
  toggleNotNecessary,
}) => {
  const [dropdownState, setDropdownState] = useState({
    isNecessaryOpen: false,
    isOptionalOpen: false,
  });
  const { t } = useTranslation("cookiesettings_modal");

  return (
    <div className="mt-8 text-small">
      <div className="collapse rounded-none bg-transparent">
        <input type="checkbox" className="hidden" id="toggle-necessary" />
        <label
          onClick={() =>
            setDropdownState({
              ...dropdownState,
              isNecessaryOpen: !dropdownState.isNecessaryOpen,
            })
          }
          htmlFor="toggle-necessary"
          className="collapse-title flex cursor-pointer flex-row items-center justify-between rounded-md border-none bg-[#1b1c1d] p-4 font-medium text-neutral-content"
        >
          <div className="flex flex-row items-center gap-2">
            <ChevronDown
              className={classNames(
                "h-4 w-4 fill-primary-content duration-300",
                {
                  "rotate-none": dropdownState.isNecessaryOpen,
                  "-rotate-90": !dropdownState.isNecessaryOpen,
                },
              )}
            />
            <div>{t("neccesary")}</div>
          </div>
          <div>{t("always_enabled")}</div>
        </label>

        <div className="collapse-content prose mt-5 max-w-full bg-transparent px-0 text-small-tall text-neutral-content prose-blockquote:text-neutral-content">
          {necessary}
        </div>
      </div>

      <div className="collapse rounded-none bg-transparent">
        <input type="checkbox" className="hidden" id="toggle-mandatory" />
        <label
          onClick={() =>
            setDropdownState({
              ...dropdownState,
              isOptionalOpen: !dropdownState.isOptionalOpen,
            })
          }
          htmlFor="toggle-mandatory"
          className="group collapse-title flex cursor-pointer flex-row items-center justify-between rounded-md border-none bg-[#1b1c1d] p-4 font-medium text-neutral-content"
        >
          <div className="flex flex-row items-center gap-2">
            <ChevronDown
              className={classNames(
                "h-4 w-4 fill-primary-content duration-300",
                {
                  "rotate-none": dropdownState.isOptionalOpen,
                  "-rotate-90": !dropdownState.isOptionalOpen,
                },
              )}
            />
            <div>{t("non_neccesary")}</div>
          </div>

          <div className="form-control relative z-10">
            <label className="label cursor-pointer gap-2">
              <span className="text-neutral-content">
                {isNotNecessaryEnabled ? t("enabled") : t("disabled")}
              </span>
              <label className="relative inline-flex cursor-pointer items-center">
                <input
                  type="checkbox"
                  className="peer sr-only"
                  checked={isNotNecessaryEnabled}
                  onChange={(event) => toggleNotNecessary(event.target.checked)}
                />
                <div className="h-8 w-16 rounded-full bg-base-400 transition-all duration-300 after:absolute after:left-[2px] after:top-[2px] after:h-7.5 after:w-7.5 after:rounded-full after:bg-white after:transition-all after:content-[''] peer-checked:bg-green peer-checked:after:translate-x-8 peer-focus:ring-primary-content" />
              </label>
            </label>
          </div>
        </label>

        <div className="collapse-content prose mt-5 max-w-full bg-transparent px-0 text-small-tall text-neutral-content prose-blockquote:text-neutral-content">
          {nonNecessary}
        </div>
      </div>
    </div>
  );
};
